import api from '../clients/api';

import { BillingGroupMeili } from '@/features/billing-groups/api/types/billing-group';
import { VisitorMeili } from '@/features/visitors/api/types/visitor';
import { Visit } from '@/features/visits/api/types/visits';
import { MeiliSearchResponse } from '@/hooks/meilisearch/types/meilisearch-response';
import { SearchState } from '@/hooks/meilisearch/types/search-state';

class MeiliApi {
  async fetchVisits(searchState: SearchState): Promise<MeiliSearchResponse<Visit>> {
    const { data } = await api.post('/search/visits', { ...searchState });

    return data;
  }

  async fetchVisitors(
    searchState: SearchState,
    page: number,
    perPage: number,
  ): Promise<MeiliSearchResponse<VisitorMeili>> {
    const { data } = await api.post('/search/visitors', {
      ...searchState,
      offset: page * perPage - perPage,
      limit: perPage,
    });

    return data;
  }

  async fetchBillingGroups(
    searchState: SearchState,
  ): Promise<MeiliSearchResponse<BillingGroupMeili>> {
    const { data } = await api.post('/search/billing-groups', { ...searchState });

    return data;
  }
}

export const meiliApi = new MeiliApi();
